export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-align-left-acbe4eea3ef58d510f705dc7eaef532a.svg";